// Shared field definitions for the Sales Leads create/edit forms.
// queryString, status, leadId and conversion fields are server-managed and not edited here.
export const LEAD_TYPE_OPTIONS = [
  { value: 'dealer', label: 'Dealer (specific prospect)' },
  { value: 'rep_card', label: 'Rep card (business-card link)' },
];

// Which fields are required depends on the lead type.
export const requiredFor = (name, leadType) =>
  leadType === 'rep_card'
    ? name === 'salesRep' || name === 'salesRepPhone'
    : name === 'contactName' || name === 'businessName';

export const SALES_LEAD_FIELDS = [
  { name: 'contactName', label: 'Contact Name' },
  { name: 'businessName', label: 'Dealership / Business Name' },
  { name: 'businessEmail', label: 'Business Email', type: 'email' },
  { name: 'businessPhone', label: 'Business Phone' },
  { name: 'addr1', label: 'Address 1' },
  { name: 'addr2', label: 'Address 2' },
  { name: 'city', label: 'City' },
  { name: 'state', label: 'State' },
  { name: 'zip', label: 'ZIP' },
  { name: 'salesRep', label: 'Sales Rep' },
  { name: 'salesRepPhone', label: 'Sales Rep Phone' },
  { name: 'trialDays', label: 'Trial Period (days)', type: 'number' },
  { name: 'trialScans', label: 'Trial Scans', type: 'number' },
  { name: 'discountPercent', label: 'Discount (%)', type: 'number' },
];

// Fields supplied as batch-wide defaults during bulk import (not mapped per column):
// trial days / scans / discount plus the sales rep name and phone.
export const IMPORT_DEFAULT_FIELDS = ['trialDays', 'trialScans', 'discountPercent', 'salesRep', 'salesRepPhone'];

// Fields that can be mapped from spreadsheet columns during bulk import.
export const IMPORTABLE_FIELDS = SALES_LEAD_FIELDS.filter((f) => !IMPORT_DEFAULT_FIELDS.includes(f.name));

export const landingUrlFor = (queryString) => {
  const base = (process.env.REACT_APP_LANDING_URL || '').replace(/\/$/, '');
  return `${base}/landing?ref=${queryString}`;
};
